import React from 'react'
import { Form } from 'semantic-ui-react'
import { FilterSchema } from '@adc/blueprint'
import CheckboxField from '../../../formFields/checkboxField'
import StandardFieldLabel from '../../../formFields/formFieldWrapper/standardFieldLabel'

type BooleanProps = FilterSchema.FilterLayoutProps<
  FilterSchema.FilterBooleanDefinition,
  FilterSchema.BooleanValueType
>

const Boolean: React.FunctionComponent<BooleanProps> = ({
  definition,
  value,
  elmId,
  onChange,
}) => {
  const label = definition.label as string // TODO: deal with react node
  return (
    <Form style={{ marginTop: 6 }}>
      <CheckboxField
        key={label}
        compact={false}
        label={
          <StandardFieldLabel
            elmId={`${elmId}_${definition.name}_label`}
            label={definition.label as string}
            subLabel={(definition.description as string) || ''}
          />
        }
        elmId={`${elmId}_${definition.name}`}
        name={definition.name}
        value={definition.name}
        role='info'
        // tooltip={definition.tooltip} // TODO handle tooltips
        checked={value}
        onChange={(
          // @ts-ignore don't need e
          e: React.ChangeEvent<HTMLInputElement>,
          data: Record<string, unknown>
        ) => {
          onChange(definition.name, data.checked as boolean)
        }}
      />
    </Form>
  )
}

export default Boolean
